import { render, staticRenderFns } from "./portal_footer.vue?vue&type=template&id=080fc0e2&scoped=true&"
import script from "./portal_footer.vue?vue&type=script&lang=js&"
export * from "./portal_footer.vue?vue&type=script&lang=js&"
import style0 from "./portal_footer.vue?vue&type=style&index=0&id=080fc0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fc0e2",
  null
  
)

export default component.exports